var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.podcast)?_c('div',{staticClass:"home-podcast-slide py-4 py-md-0"},[_c('router-link',{attrs:{"to":{
      name: 'podcast-episodes',
      params: { ..._vm.podcast }
    }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.podcast.photo}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }